import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const AdCode = ({code}) => {
  const { t } = useTranslation('common')

  return (
    <p>{t('Šifra oglasa')}: {code}</p>
  )
}

AdCode.propTypes = {
  code: PropTypes.string.isRequired
}
